<script>
    export let instrVisible = true;
    export let lang = 'pl';
    import { texts } from './texts.js';
    let page = 0;
</script>

<div class="pop-ups">
    {#if page === 0}
        <div class="pop-up" id="pop-up">
            <div class="pop-up-content">
                <i class="fas fa-arrow-right fa-3x" on:click={() => page++} />
                <div class="tresc">
                    <div class="rules">
                        <h3>{texts[lang].starting_rules_header}</h3>
                        {@html texts[lang].instructions_part1}
                        <i
                            class="fas fa-times pop-up-close"
                            on:click={() => {
                                instrVisible = false;
                            }}
                        />
                    </div>
                    <div class="rules ">
                        <img
                            src="/build/img/instrukcja.jpg"
                            class="rules-img"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if page === 1}
        <div class="pop-up" id="instrukcja">
            <div class="pop-up-content">
                <i class="fas fa-arrow-right fa-3x" on:click={() => page++} />
                <i class="fas fa-arrow-left fa-3x" on:click={() => page--} />
                <div class="tura">
                    <h2>{texts[lang].example_round}</h2>
                    <div class="przyklad1">
                        <div class="zespol">
                            <div class="rewerse">
                                <i class="fas fa-users fa-4x log-orange" /><i
                                    class="fas fa-laptop fa-4x"
                                />
                            </div>
                            <h3>{texts[lang].orange_crew}</h3>
                        </div>
                        <div class="zespol">
                            <div class="rewerse">
                                <i class="fas fa-users fa-4x log-blue" /><i
                                    class="fas fa-laptop fa-4x"
                                />
                            </div>
                            <h3>{texts[lang].blue_crew}</h3>
                        </div>
                        <div class="zespol">
                            <div class="rewerse">
                                <i class="fas fa-users fa-4x log-green" /><i
                                    class="fas fa-laptop fa-4x"
                                />
                            </div>
                            <h3>{texts[lang].green_crew}</h3>
                        </div>
                        <div class="zespol">
                            <div class="rewerse">
                                <i class="fas fa-users fa-4x log-violet" /><i
                                    class="fas fa-laptop fa-4x"
                                />
                            </div>
                            <h3>{texts[lang].violet_crew}</h3>
                        </div>
                    </div>
                    <div class="przyklad1">
                        <div class="p">
                            {@html texts[lang].instructions_part2}
                            <button
                                class="message_form_button "
                                type="submit"
                                disabled>{texts[lang].confirm}</button
                            >
                        </div>
                        <div class="item">
                            <label
                                >{texts[lang].pirate_header}
                                <input
                                    type="radio"
                                    id="wybor1"
                                    name="chlopczyk"
                                    value="pirat"
                                    class="visually-hidden"
                                />
                                <div class="control-me1" />
                            </label>
                            <label
                                >{texts[lang].explorer_header}
                                <input
                                    type="radio"
                                    id="wybor2"
                                    name="chlopczyk"
                                    value="odkrywca"
                                    class="visually-hidden"
                                />
                                <div class="control-me2" />
                            </label>
                            <i
                                class="fas fa-times pop-up-close"
                                on:click={() => {
                                    instrVisible = false;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if page === 2}
        <div class="pop-up" id="instrukcja1">
            <div class="pop-up-content">
                <i
                    class="fas fa-arrow-right fa-3x move"
                    on:click={() => page++}
                />
                <i class="fas fa-arrow-left fa-3x" on:click={() => page--} />
                <div class="tura">
                    <h2>{texts[lang].example_round}</h2>
                    {@html texts[lang].instructions_part3}
                    <div class="rewerse">
                        <div class="karta">
                            <div>
                                <img
                                    src="build/img/odkrywca-picked.png"
                                    alt=""
                                />
                            </div>
                            <div>
                                {@html texts[lang].instructions_part4}
                            </div>
                        </div>
                        <div class="karta">
                            <div>
                                <img
                                    src="build/img/odkrywca-picked.png"
                                    alt=""
                                />
                            </div>
                            <div>
                                {@html texts[lang].instructions_part5}
                                <i
                                    class="fas fa-times pop-up-close"
                                    on:click={() => {
                                        instrVisible = false;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if page === 3}
        <div class="pop-up" id="instrukcja2">
            <div class="pop-up-content">
                <i
                    class="fas fa-arrow-right fa-3x move"
                    on:click={() => page++}
                />
                <i class="fas fa-arrow-left fa-3x" on:click={() => page--} />
                <div class="tura">
                    <h2>{texts[lang].example_round}</h2>
                    {@html texts[lang].instructions_part6}
                    <div class="rewerse">
                        <div class="karta">
                            <div>
                                <img
                                    src="build/img/korsarz-picked.png"
                                    alt=""
                                />
                            </div>
                            <div>
                                {@html texts[lang].instructions_part7}
                            </div>
                        </div>
                        <div class="karta">
                            <div>
                                {@html texts[lang].instructions_part8}
                                <i
                                    class="fas fa-times pop-up-close"
                                    on:click={() => {
                                        instrVisible = false;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if page === 4}
        <div class="pop-up" id="instrukcja3">
            <div class="pop-up-content">
                <i
                    class="fas fa-arrow-right fa-3x move"
                    on:click={() => page++}
                />
                <i class="fas fa-arrow-left fa-3x" on:click={() => page--} />
                <div class="tura">
                    <h2>{texts[lang].example_round}</h2>
                    {@html texts[lang].instructions_part9}
                    <div class="rewerse">
                        <div class="karta">
                            <div>
                                <img
                                    src="build/img/korsarz-picked.png"
                                    alt=""
                                />
                            </div>
                            <div>
                                {@html texts[lang].instructions_part10}
                            </div>
                        </div>
                        <div class="karta">
                            <div>
                                {@html texts[lang].instructions_part11}
                                <i
                                    class="fas fa-times pop-up-close"
                                    on:click={() => {
                                        instrVisible = false;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if page === 5}
        <div class="pop-up" id="instrukcja4">
            <div class="pop-up-content">
                <i
                    class="fas fa-arrow-right fa-3x"
                    on:click={() => (instrVisible = false)}
                />
                <i class="fas fa-arrow-left fa-3x" on:click={() => page--} />
                <div class="przyklad">
                    <h2>{texts[lang].example_round}</h2>
                    <!-- <div>
                        <img class="cover" src="build/img/cover.png" alt="" />
                    </div> -->
                    <div class="przyklad1">
                        <div>
                            {@html texts[lang].instructions_part12}
                            <i
                                class="fas fa-times pop-up-close"
                                on:click={() => {
                                    instrVisible = false;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>
